module.exports = __webpack_public_path__ + "img/pantalla-2-4.f952cd9c.png";